/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BannerDto } from '../../models/banner-dto';

export interface BannerControllerDelete$Params {
  id: string;
}

export function bannerControllerDelete(http: HttpClient, rootUrl: string, params: BannerControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
  const rb = new RequestBuilder(rootUrl, bannerControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BannerDto>;
    })
  );
}

bannerControllerDelete.PATH = '/api/banner/{id}';
